import { PassportTemplate as Data } from '@/typings/api/Passport'
import { Model, createMessages } from '@/helpers/Model'


export class PassportPageModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить шаблон паспорта',
      edit: 'Редактировать шаблон паспорта',
      view: (data: PassportPageModel) => 'Шаблон «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'Шаблоны паспортов',
    });

    public static readonly modal_delete = createMessages({
      ...Model.modal_delete,
      delete: (data: PassportPageModel) => 'Удаление шаблона «{name}»'
        .replace('{name}', data.name || '...'),
    });

    public static getName(data: Data) {
      return data?.name ?? '...'
    }
}
